// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/oxygen.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/oxygen/oxygen.js';

mount([g0]);
